import { useState } from 'react';
import type { TDraft, TDraftOptions } from './useDraft.types.ts';

export const useDraft = <TValue>(
  saved: TValue,
  { initial = saved, isEqual = Object.is }: TDraftOptions<TValue> = {},
): TDraft<TValue> => {
  const [draft, setDraft] = useState(initial);

  const isDirty = !isEqual(draft, saved);

  return { draft, isDirty, setDraft };
};
